// extracted by mini-css-extract-plugin
export default {"WelcomeContainer":"welcome_WelcomeContainer__IqQm9","WelcomeInfo":"welcome_WelcomeInfo__i7Thg","ActionButton":"welcome_ActionButton__Qi1et"};